import React from "react";
// import { makeStyles } from "@mui/styles";
import { Grid, Container, Typography } from "@material-ui/core";

import "../../MainCSS.css";
import "./Blog2_cat.css"
const Blog2_cat = () => {
  return (
    <div>
    
      <Container className="D6_ADS_ContBlog2">
        <Grid
          container
          justify="center"
          alignItems="center"
          fixed
          className="D6_ADS_GridBlog2"
        >
          <Grid item sm={6} xs={12} className="D6_ADS_Grid1Blog2">
            <div className="D6_ADS_G1_DivBlog2">
            
     {/* <h3 className="D6_ADS_G1_DivH" style={D6_ADS_G1_DivH}>
                AbFam RadianZ
              </h3> */}
              <div className='D6_SL_WS_Grid2_HDivBlog2'>
               
               <Typography component="h3" className='D6_SL_WS_Grid2_Div_H1Blog2'>REACT/REACT-JS </Typography>
           </div>
 <Typography           component="p"
 className="D6_ADS_G1_DivPBlog2_B">

React.js/React is an open-source frontend framework that is based on JavaScript, developed by Facebook, and best known for its virtual DOM feature. </Typography>
 <Typography           component="p"
 className="D6_ADS_G1_DivPBlog2_B">

React.js is an open-source JavaScript library that is used for building user interfaces specifically for single-page applications. It's used for handling the view layer for web and mobile apps. React also allows us to create reusable UI components.  </Typography>
  
<Typography           component="p"
 className="D6_ADS_G1_DivPBlog2_B">
React makes it painless to create interactive UIs. Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.              
</Typography>
 </div>
          </Grid>

          <Grid item xs={12} sm={6} className="D6_ADS_Grid1Blog1">
            {/* <div className="D6_ADS_G1_DivBlog1" >
              <img src={SkinImage} alt="Image" className="D6_ADS_ImgBlog1" />
            </div> */}
          </Grid>

      
      
        </Grid>

      </Container>
    </div>
  );
};

export default Blog2_cat;
